var _path, _path2, _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCanadaIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    "aria-labelledby": titleId,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.005 10.56",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "canadaFlagTitle"
  }, "Flag of Canada") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "canadaFlagTitle"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "canadaFlagWhite",
    d: "M4.255,0v10.56h9.494V0H4.255ZM10.91,7.609l-1.804-.203c-.024.387-.025.708-.006,1.074l.047.906-.294.004.084-1.981-1.843.197c.069-.26.123-.48.132-.683l-1.763-1.494.46-.257-.319-1.268,1.102.221.206-.561.764.891c.032.037.132.082.168.093.048.014.119-.152.11-.205l-.34-1.905.694.29.693-1.32.697,1.318.691-.284-.336,1.89c-.008.044.028.177.057.201.038.033.172-.022.21-.066l.775-.904.203.561,1.103-.219-.317,1.241.458.285-1.788,1.518.156.66Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "canadaFlagRed",
    d: "M12.084,5.146l.317-1.241-1.103.219-.203-.561-.775.904c-.038.044-.172.099-.21.066-.028-.024-.064-.157-.057-.201l.336-1.89-.691.284-.697-1.318-.693,1.32-.694-.29.34,1.905c.009.053-.062.219-.11.205-.036-.011-.136-.056-.168-.093l-.764-.891-.206.561-1.102-.221.319,1.268-.46.257,1.763,1.494c-.01.203-.063.424-.132.683l1.843-.197-.084,1.981.294-.004-.047-.906c-.019-.366-.018-.687.006-1.074l1.804.203-.156-.66,1.788-1.518-.458-.285Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "canadaFlagRed",
    y: 0,
    width: 4.255,
    height: 10.56
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "canadaFlagRed",
    x: 13.749,
    y: 0,
    width: 4.255,
    height: 10.56
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanadaIcon);
export default __webpack_public_path__ + "static/media/Canada_Icon.209757fcd84e05ec2da8c8b4254e26a1.svg";
export { ForwardRef as ReactComponent };